import Vue from "vue";

import Winner from "./InstantWinner.vue";

export function load() {
    const selector = "instant-winner";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(Winner, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
